export const LOADING_SAVING_DATA = "LOADING_SAVING_DATA";
export const SUCCESS_PRESENTATION_DATA = "SUCCESS_PRESENTATION_DATA";
export const LOADING_PRESENTATION_DATA = "LOADING_PRESENTATION_DATA";
export const RESET_PRESENTATION_DATA = "RESET_PRESENTATION_DATA";
